
    import './styles.scoped.css';
    export default {
  "button-dropdown": "awsui_button-dropdown_sne0l_11j14_141",
  "full-width": "awsui_full-width_sne0l_11j14_144",
  "items-list-container": "awsui_items-list-container_sne0l_11j14_149",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_11j14_1",
  "rotate": "awsui_rotate_sne0l_11j14_168",
  "rotate-open": "awsui_rotate-open_sne0l_11j14_182",
  "header": "awsui_header_sne0l_11j14_186",
  "title": "awsui_title_sne0l_11j14_197",
  "description": "awsui_description_sne0l_11j14_198",
  "trigger-button": "awsui_trigger-button_sne0l_11j14_202",
  "loading": "awsui_loading_sne0l_11j14_206",
  "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_11j14_210",
  "trigger-item": "awsui_trigger-item_sne0l_11j14_213",
  "has-no-text": "awsui_has-no-text_sne0l_11j14_222",
  "visual-refresh": "awsui_visual-refresh_sne0l_11j14_225",
  "has-trigger-text": "awsui_has-trigger-text_sne0l_11j14_236",
  "variant-normal": "awsui_variant-normal_sne0l_11j14_239",
  "split-trigger": "awsui_split-trigger_sne0l_11j14_210",
  "dropdown-trigger": "awsui_dropdown-trigger_sne0l_11j14_250",
  "main-action-full-width": "awsui_main-action-full-width_sne0l_11j14_254",
  "main-action-trigger-full-width": "awsui_main-action-trigger-full-width_sne0l_11j14_258",
  "filter": "awsui_filter_sne0l_11j14_262",
  "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_11j14_268"
};
  